var map = {
	"./QuickSwap_logo.png": "./src/assets/images/QuickSwap_logo.png",
	"./arkane.svg": "./src/assets/images/arkane.svg",
	"./arrow-down-blue.svg": "./src/assets/images/arrow-down-blue.svg",
	"./arrow-down-grey.svg": "./src/assets/images/arrow-down-grey.svg",
	"./arrow-right-white.png": "./src/assets/images/arrow-right-white.png",
	"./arrow-right.svg": "./src/assets/images/arrow-right.svg",
	"./big_unicorn.png": "./src/assets/images/big_unicorn.png",
	"./blue-loader.svg": "./src/assets/images/blue-loader.svg?dd02",
	"./circle-grey.svg": "./src/assets/images/circle-grey.svg",
	"./circle.svg": "./src/assets/images/circle.svg",
	"./coinbaseWalletIcon.svg": "./src/assets/images/coinbaseWalletIcon.svg",
	"./cropto_logo-beta.png": "./src/assets/images/cropto_logo-beta.png",
	"./cropto_logo.svg": "./src/assets/images/cropto_logo.svg?4a8d",
	"./dropdown-blue.svg": "./src/assets/images/dropdown-blue.svg",
	"./dropdown.svg": "./src/assets/images/dropdown.svg?c994",
	"./dropup-blue.svg": "./src/assets/images/dropup-blue.svg",
	"./ethereum-logo.png": "./src/assets/images/ethereum-logo.png",
	"./fortmaticIcon.png": "./src/assets/images/fortmaticIcon.png",
	"./gnosis_safe.png": "./src/assets/images/gnosis_safe.png",
	"./law-9142_256.gif": "./src/assets/images/law-9142_256.gif",
	"./link.svg": "./src/assets/images/link.svg",
	"./loading-balances.gif": "./src/assets/images/loading-balances.gif",
	"./logo.png": "./src/assets/images/logo.png",
	"./logo_circle.png": "./src/assets/images/logo_circle.png",
	"./magnifying-glass.svg": "./src/assets/images/magnifying-glass.svg",
	"./matic.png": "./src/assets/images/matic.png",
	"./menu.svg": "./src/assets/images/menu.svg",
	"./metamask.png": "./src/assets/images/metamask.png",
	"./noise.png": "./src/assets/images/noise.png",
	"./plus-blue.svg": "./src/assets/images/plus-blue.svg",
	"./plus-grey.svg": "./src/assets/images/plus-grey.svg",
	"./portisIcon.png": "./src/assets/images/portisIcon.png",
	"./qsbg.png": "./src/assets/images/qsbg.png",
	"./question-mark.svg": "./src/assets/images/question-mark.svg",
	"./question.svg": "./src/assets/images/question.svg",
	"./quick_logo.jpeg": "./src/assets/images/quick_logo.jpeg",
	"./spinner.svg": "./src/assets/images/spinner.svg",
	"./token-list/lists-dark.png": "./src/assets/images/token-list/lists-dark.png",
	"./token-list/lists-light.png": "./src/assets/images/token-list/lists-light.png",
	"./token-logo.png": "./src/assets/images/token-logo.png",
	"./trustWallet.png": "./src/assets/images/trustWallet.png",
	"./venly.svg": "./src/assets/images/venly.svg",
	"./walletConnectIcon.svg": "./src/assets/images/walletConnectIcon.svg?02df",
	"./x.svg": "./src/assets/images/x.svg?3361",
	"./xl_uni.png": "./src/assets/images/xl_uni.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";